import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
} from '@mui/material';

const DeleteConfirmationDialog = ({ open, onClose, onConfirm, title, description }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    setError('');
    setSuccess(false);
    try {
      await onConfirm();
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'An unexpected error occurred.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    // Reset state on close
    setLoading(false);
    setError('');
    setSuccess(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {loading ? (
          <CircularProgress />
        ) : success ? (
          <DialogContentText>Report deleted successfully!</DialogContentText>
        ) : error ? (
          <DialogContentText color="error">{error}</DialogContentText>
        ) : (
          <DialogContentText>{description}</DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        {success || error ? (
          <Button onClick={handleClose}>Close</Button>
        ) : (
          <>
            <Button onClick={handleClose} disabled={loading}>
              Cancel
            </Button>
            <Button onClick={handleConfirm} color="primary" disabled={loading}>
              {loading ? 'Deleting...' : 'Delete'}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;